import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M20 7.125H4a1.125 1.125 0 0 1 0-2.25h16a1.125 1.125 0 0 1 0 2.25Zm0 6H4a1.125 1.125 0 0 1 0-2.25h16a1.125 1.125 0 0 1 0 2.25Zm0 6H4a1.125 1.125 0 0 1 0-2.25h16a1.125 1.125 0 0 1 0 2.25Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }